// TODO: remove after refactoring
import { setHasProjects } from '@/entities/project/model/useProjectsStore';

import { AUTH_API } from '@/shared/api/amplify';
import { queryClient } from '@/shared/config';
import { LS_DUBBING_WARNING_MODAL_DISABLED } from '@/shared/constants/dubbing';
import { clearUserChurnkeyState } from '@/shared/thirdParty/churnkey';
import { GTMEvents } from '@/shared/thirdParty/gtm';
import { shutdownMixpanel } from '@/shared/thirdParty/mixpanel';

import { clearTusLSEntries } from './tus';

export const logout = async () => {
  localStorage.removeItem(LS_DUBBING_WARNING_MODAL_DISABLED);
  // Canonical constant is ENTRY_SOURCE_KEY in src/entities/entrySource/lib/constants.ts.
  // The literal is inlined here because shared/ cannot import from entities/ per FSD boundaries.
  // If the key value changes, update both places.
  localStorage.removeItem('entry_source');

  clearUserChurnkeyState();
  shutdownMixpanel();

  GTMEvents.setUserId(undefined);
  queryClient.clear();
  setHasProjects(false);
  clearTusLSEntries.all();

  await AUTH_API.signOut();

  window.location.reload();
};
